import { render, staticRenderFns } from "./nurseDetail.vue?vue&type=template&id=bb81d78e&scoped=true"
import script from "./nurseDetail.vue?vue&type=script&lang=js"
export * from "./nurseDetail.vue?vue&type=script&lang=js"
import style0 from "./nurseDetail.vue?vue&type=style&index=0&id=bb81d78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb81d78e",
  null
  
)

export default component.exports